/*! V11.1 Ultra Performance (Home + Product) */
(function () {
  function isProductTemplate() {
    var cls = (document.body && document.body.className) ? document.body.className : '';
    var htmlCls = document.documentElement.className || '';
    return (cls.indexOf('template-product') !== -1) || (htmlCls.indexOf('template-product') !== -1);
  }

  function markLazySections() {
    var main = document.querySelector('main');
    if (!main) return;
    var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
    if (!sections.length) return;

    // Keep the first N sections "eager". Everything else becomes lazy-rendered.
    // Home: keep 2 (hero + next section). Product: keep 2 (gallery/buybox + next).
    var keep = isProductTemplate() ? 2 : 2;

    for (var i = 0; i < sections.length; i++) {
      if (i >= keep) sections[i].classList.add('v11-lazy-section');
    }
  }

  function setupSectionObserver() {
    if (!('IntersectionObserver' in window)) return;
    var nodes = document.querySelectorAll('.v11-lazy-section');
    if (!nodes.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('v11-visible');
        io.unobserve(e.target);
      });
    }, { rootMargin: '350px' });

    Array.prototype.forEach.call(nodes, function (el) { io.observe(el); });
  }

  function autoLazyImages() {
    // Add loading="lazy" to images clearly below the first viewport, without touching LCP images.
    var imgs = document.images;
    if (!imgs || !imgs.length) return;

    var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.hasAttribute('loading')) continue;

      // Skip likely LCP candidates
      if (img.closest('.header, header, .hero, .banner, .product__media, .product-media, .main-product')) continue;

      try {
        var rect = img.getBoundingClientRect();
        if (rect.top > vh * 1.2) img.setAttribute('loading', 'lazy');
      } catch (e) {}
    }
  }

  function deferNonCriticalStyles() {
    // Optional: convert preload styles with data-v11-onload to non-blocking
    var links = document.querySelectorAll('link[data-v11-onload][rel="preload"][as="style"]');
    Array.prototype.forEach.call(links, function (l) {
      l.addEventListener('load', function () {
        l.rel = 'stylesheet';
      });
    });
  }

  function onReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }



  function setupRoyalKadooLiveProof() {
    if (!isProductTemplate()) return;

    function parseJson(el, attr) {
      try { return JSON.parse(el.getAttribute(attr) || '{}'); }
      catch (e) { return {}; }
    }

    function toInt(value, fallback) {
      var number = parseInt(value, 10);
      return isNaN(number) ? fallback : number;
    }

    function randomBetween(min, max) {
      min = toInt(min, 1);
      max = toInt(max, min);
      if (max < min) max = min;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function stableValue(key, min, max, ttl) {
      var now = Date.now();
      try {
        var cached = JSON.parse(localStorage.getItem(key) || 'null');
        if (cached && cached.expires > now && typeof cached.value === 'number') return cached.value;
      } catch (e) {}
      var value = randomBetween(min, max);
      try { localStorage.setItem(key, JSON.stringify({ value: value, expires: now + ttl })); } catch (e) {}
      return value;
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-live-view]'), function (el) {
      if (el.dataset.rkLiveReady === 'true') return;
      el.dataset.rkLiveReady = 'true';
      var cfg = parseJson(el, 'data-live-view');
      var min = toInt(cfg.min, 1);
      var max = toInt(cfg.max, Math.max(min, 18));
      var interval = Math.max(toInt(cfg.interval, 4000), 2000);
      var countNode = el.querySelector('[data-count]');
      if (!countNode) return;

      function updateLiveCount() {
        countNode.textContent = randomBetween(min, max);
      }

      updateLiveCount();
      el.classList.remove('t4s-dn');
      el.classList.add('rk-live-proof-ready');
      setInterval(updateLiveCount, interval);
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-flash-sold]'), function (el) {
      if (el.dataset.rkSoldReady === 'true') return;
      el.dataset.rkSoldReady = 'true';
      var cfg = parseJson(el, 'data-flash-sold');
      var id = cfg.id || (location.pathname || 'product');
      var ttl = Math.max(toInt(cfg.time, 120000), 60000);
      var sold = stableValue('rk_sold_qty_' + id, toInt(cfg.mins, 3), toInt(cfg.maxs, 26), ttl);
      var hours = stableValue('rk_sold_hour_' + id, toInt(cfg.mint, 2), toInt(cfg.maxt, 12), ttl);
      var soldNode = el.querySelector('[data-sold]');
      var hourNode = el.querySelector('[data-hour]');
      if (soldNode) soldNode.textContent = sold;
      if (hourNode) hourNode.textContent = hours;
      el.classList.remove('t4s-dn');
      el.classList.add('rk-live-proof-ready');
    });
  }


  function setupRoyalKadooRecentlyViewedClean() {
    if (!isProductTemplate()) return;

    function normalizePath(href) {
      try {
        var url = new URL(href, window.location.origin);
        return url.pathname.replace(/\/$/, '');
      } catch (e) {
        return '';
      }
    }

    function getCardPath(card) {
      var link = card.querySelector('a[href*="/products/"]');
      return link ? normalizePath(link.getAttribute('href')) : '';
    }

    function cleanSection() {
      var section = document.querySelector('.id_recently_viewed');
      if (!section) return;

      var currentPath = normalizePath(window.location.href);
      var seen = {};
      var visibleCount = 0;
      var cards = Array.prototype.slice.call(section.querySelectorAll('.t4s-product, .rk-rec-card, .t4s-recent-card, .t4s-col-item'));

      cards.forEach(function (card) {
        if (!card || card.dataset.rkRvChecked === 'true') return;
        var path = getCardPath(card);
        if (!path) return;
        card.dataset.rkRvChecked = 'true';
        if (path === currentPath || seen[path]) {
          if (card.parentNode) card.parentNode.removeChild(card);
          return;
        }
        seen[path] = true;
        visibleCount += 1;
      });

      if (!visibleCount) {
        var uniqueLinks = {};
        Array.prototype.forEach.call(section.querySelectorAll('a[href*="/products/"]'), function (a) {
          var path = normalizePath(a.getAttribute('href'));
          if (path && path !== currentPath) uniqueLinks[path] = true;
        });
        visibleCount = Object.keys(uniqueLinks).length;
      }

      if (visibleCount === 0) {
        section.classList.add('rk-recent-empty');
      } else {
        section.classList.remove('rk-recent-empty');
      }
    }

    cleanSection();
    setTimeout(cleanSection, 450);
    setTimeout(cleanSection, 1200);

    var section = document.querySelector('.id_recently_viewed');
    if (section && window.MutationObserver && section.dataset.rkRvObserver !== 'true') {
      section.dataset.rkRvObserver = 'true';
      new MutationObserver(function () { cleanSection(); }).observe(section, { childList: true, subtree: true });
    }
  }



  function setupRoyalKadooRecentlyViewedPro() {
    if (!isProductTemplate()) return;

    var wrap = document.getElementById('recently_wrap');
    var section = document.querySelector('.id_recently_viewed');
    if (!wrap || !section) return;
    if (wrap.dataset.rkRvProInit === 'true') return;
    wrap.dataset.rkRvProInit = 'true';

    var STORE_KEY = 'rk_recently_viewed_v2';
    var LEGACY_KEY = 'nt_recent';
    var maxItems = 24;
    var limit = parseInt(wrap.getAttribute('data-limit'), 10);
    if (!limit || limit < 1) limit = 4;

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function normalizePath(href) {
      try {
        var url = new URL(href || '', window.location.origin);
        return url.pathname.replace(/\/$/, '');
      } catch (e) {
        return '';
      }
    }

    function getProductKey(item) {
      if (!item) return '';
      return item.handle || (item.id ? String(item.id) : '') || normalizePath(item.url);
    }

    function loadStore() {
      try {
        var parsed = JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
        if (!Array.isArray(parsed)) return [];
        return parsed.filter(function (item) { return item && getProductKey(item); });
      } catch (e) {
        return [];
      }
    }

    function saveStore(items) {
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify(items.slice(0, maxItems)));
      } catch (e) {}
    }

    function parseCurrentProduct() {
      var data = null;
      var jsonNode = document.querySelector('[data-rk-recent-current]');
      if (jsonNode && jsonNode.textContent) {
        try { data = JSON.parse(jsonNode.textContent); } catch (e) { data = null; }
      }
      if (!data) data = {};
      if (!data.id && wrap.getAttribute('data-id')) data.id = wrap.getAttribute('data-id');
      if (!data.handle && wrap.getAttribute('data-handle')) data.handle = wrap.getAttribute('data-handle');
      if (!data.url) data.url = normalizePath(window.location.href);
      if (!data.title) {
        var titleNode = document.querySelector('.t4s-product__title, .product__title, h1');
        data.title = titleNode ? titleNode.textContent.trim() : document.title.replace(/\s+[–|-].*$/, '');
      }
      if (!data.image) {
        var imgNode = document.querySelector('.t4s-product__media img, .product__media img, img[fetchpriority="high"]');
        data.image = imgNode ? (imgNode.currentSrc || imgNode.src || imgNode.getAttribute('data-src') || '') : '';
      }
      if (!data.price) {
        var priceNode = document.querySelector('.t4s-product-price, .price, [data-product-price]');
        data.price = priceNode ? priceNode.textContent.replace(/\s+/g, ' ').trim() : '';
      }
      data.ts = Date.now();
      return getProductKey(data) ? data : null;
    }

    function syncLegacyIds(current, previous) {
      var ids = [];
      function add(id) {
        id = id == null ? '' : String(id).trim();
        if (id && ids.indexOf(id) === -1) ids.push(id);
      }
      if (current && current.id) add(current.id);
      previous.forEach(function (item) { if (item && item.id) add(item.id); });
      try {
        (localStorage.getItem(LEGACY_KEY) || '').split(',').forEach(add);
        localStorage.setItem(LEGACY_KEY, ids.slice(0, maxItems).join(','));
      } catch (e) {}
      return ids;
    }

    function hasServerRenderedProducts() {
      return wrap.querySelector('.t4s-product, .rk-rec-card, .t4s-col-item, .product-card') !== null;
    }

    function reinitThemeCards() {
      try { if (window.T4SThemeSP && T4SThemeSP.reinitProductGridItem) T4SThemeSP.reinitProductGridItem(); } catch (e) {}
      try { if (window.T4SThemeSP && T4SThemeSP.Reveal) T4SThemeSP.Reveal(); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('theme:recently-viewed:loaded')); } catch (e) {}
    }

    function revealSection() {
      section.classList.remove('rk-recent-empty');
      section.classList.add('rk-recent-ready');
      section.style.display = 'block';
      wrap.style.display = 'block';
      wrap.style.height = 'auto';
      wrap.style.overflow = 'visible';
    }

    function hideSection() {
      if (hasServerRenderedProducts() || wrap.querySelector('.rk-rv-card')) return;
      section.classList.add('rk-recent-empty');
      section.classList.remove('rk-recent-ready');
    }

    function getMoneyHtml(item) {
      var price = item.price || '';
      var compare = item.compare && item.compare !== item.price ? item.compare : '';
      if (!price) return '';
      return '<div class="rk-rv-card__price">' + (compare ? '<del>' + escapeHtml(compare) + '</del>' : '') + '<ins>' + escapeHtml(price) + '</ins></div>';
    }

    function renderFallback(items) {
      if (hasServerRenderedProducts()) {
        revealSection();
        return true;
      }
      items = (items || []).filter(function (item) { return item && item.url && item.title; }).slice(0, limit);
      if (!items.length) {
        hideSection();
        return false;
      }
      var heading = wrap.getAttribute('data-heading') || 'Recently viewed';
      var subheading = wrap.getAttribute('data-subheading') || 'Pieces you checked recently, saved here for faster comparison.';
      var html = '<div class="rk-rv-section" data-rk-rv-fallback="true">';
      html += '<div class="rk-rv-head"><span class="rk-rv-kicker">RoyalKadoo</span><h2 class="rk-rv-title">' + escapeHtml(heading) + '</h2>';
      if (subheading) html += '<p class="rk-rv-subtitle">' + escapeHtml(subheading) + '</p>';
      html += '</div><div class="rk-rv-grid">';
      items.forEach(function (item) {
        var url = item.url || ('/products/' + item.handle);
        html += '<article class="rk-rv-card"><a class="rk-rv-card__media" href="' + escapeHtml(url) + '" aria-label="' + escapeHtml(item.title) + '">';
        if (item.image) {
          html += '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">';
        } else {
          html += '<span class="rk-rv-card__placeholder">RK</span>';
        }
        html += '</a><div class="rk-rv-card__body">';
        if (item.vendor) html += '<div class="rk-rv-card__vendor">' + escapeHtml(item.vendor) + '</div>';
        html += '<h3 class="rk-rv-card__title"><a href="' + escapeHtml(url) + '">' + escapeHtml(item.title) + '</a></h3>';
        html += getMoneyHtml(item);
        html += '<a class="rk-rv-card__cta" href="' + escapeHtml(url) + '">View again</a>';
        html += '</div></article>';
      });
      html += '</div></div>';
      wrap.innerHTML = html;
      revealSection();
      return true;
    }

    function tryServerRender(idList) {
      if (!window.fetch || !idList || !idList.length || !wrap.getAttribute('data-sid')) return;
      var ids = idList.filter(function (id) { return id && String(id) !== String(wrap.getAttribute('data-id')); }).slice(0, limit);
      if (!ids.length) return;
      var searchUrl = wrap.getAttribute('data-search-url') || '/search';
      var query = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
      var url = searchUrl + '?section_id=' + encodeURIComponent(wrap.getAttribute('data-sid')) + '&type=product&options%5Bunavailable_products%5D=' + encodeURIComponent(wrap.getAttribute('data-unpr') || 'show') + '&q=' + encodeURIComponent(query);
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then(function (html) {
          html = (html || '').trim();
          if (!html || html === 'NVT_94' || hasServerRenderedProducts() || wrap.querySelector('.rk-rv-card')) return;
          var temp = document.createElement('div');
          temp.innerHTML = html;
          if (!temp.querySelector('.t4s-product, .t4s-col-item, .product-card')) return;
          wrap.innerHTML = html;
          revealSection();
          reinitThemeCards();
        })
        .catch(function () {});
    }

    var current = parseCurrentProduct();
    var previous = loadStore();
    var currentKey = getProductKey(current);
    var displayItems = previous.filter(function (item) { return getProductKey(item) !== currentKey; });
    var saved = [];
    if (current) saved.push(current);
    displayItems.forEach(function (item) {
      if (!item || getProductKey(item) === currentKey) return;
      if (saved.some(function (savedItem) { return getProductKey(savedItem) === getProductKey(item); })) return;
      saved.push(item);
    });
    saveStore(saved);
    var legacyIds = syncLegacyIds(current, displayItems);

    tryServerRender(legacyIds);
    setTimeout(function () { renderFallback(displayItems); }, 900);
    setTimeout(function () { renderFallback(displayItems); }, 2100);
  }

  onReady(function () {
    markLazySections();
    autoLazyImages();
    setupSectionObserver();
    deferNonCriticalStyles();
    setupRoyalKadooLiveProof();
    setupRoyalKadooRecentlyViewedClean();
    setupRoyalKadooRecentlyViewedPro();
    document.addEventListener('shopify:section:load', function () {
      setupRoyalKadooLiveProof();
      setupRoyalKadooRecentlyViewedClean();
      setupRoyalKadooRecentlyViewedPro();
    });
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
  });
})();
